<div class="modal-header">
    <div class="row col-12">        
        <div class="modal-title col-10">
            <h1>Slet kunde</h1>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true" ><i class="fa-solid fa-x"></i></span>
                </button>    
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row">
        @if(isLoading)
        {
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
                <div class="continuous-loader" role="status"></div>
                <h4 class="mt-2">{{ loadingText }}</h4>
            </div>
        }
        @else 
        {
            <div class="row mb-3">
                @if (deleteCaption != '')
                {
                    <div class="col-12">
                        <h4>{{ deleteCaption }}</h4>
                    </div>
                }
                @if (deleteMesaage != '')
                {
                    <div class="col-12">
                        <p>{{ deleteMesaage }}</p>
                    </div>
                }
            </div>
        }
    </div>
    <div class="modal-footer bg-transparent">
        <button class="btn btn-danger float-end" (click)="deleteCustomer()" [disabled]="isDeletingCustomer" >
            @if(isDeletingCustomer)
            {
                <div class="spinner-border spinner-border-sm me-2" role="status">
                    <span class="visually-hidden">Sletter...</span>
                </div>
            }                    
            Udfør</button> 
    </div>
</div>
